// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__xrRsk","active":"LanguageItems_active__1khZA"};